import { render, staticRenderFns } from "./UploadCustomize.vue?vue&type=template&id=caef41cc&scoped=true&"
import script from "./UploadCustomize.vue?vue&type=script&lang=js&"
export * from "./UploadCustomize.vue?vue&type=script&lang=js&"
import style0 from "./UploadCustomize.vue?vue&type=style&index=0&id=caef41cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caef41cc",
  null
  
)

export default component.exports